// Get this user's storage.

import currentUser from './currentUser';
import legacyUser from './legacyUser';
import newUser from './newUser';

function getStorage() {

	if (window.localStorage.tabbyCatVersion1) {
		// CURRENT USER - Get their storage from the new place - chrome.storage.
		return currentUser();

	} else if (window.localStorage.goodies) {
		// LEGACY USER - Get their storage from the old place - localStorage.
		return legacyUser();
	}

	// NEW USER - Initialize state.
	return newUser();
}

export default getStorage;



// WEBPACK FOOTER //
// ./src/utils/getStorage/index.js